const CUSTOM_MCP_TOOL_ACCESS = Object.freeze({
  READ: 'read',
  WRITE: 'write',
  UNSPECIFIED: 'unspecified',
});

const getCustomMcpToolDeclaredAccess = (tool = {}) => {
  if (tool.destructiveHint === true || tool.readOnlyHint === false) {
    return CUSTOM_MCP_TOOL_ACCESS.WRITE;
  }
  if (tool.readOnlyHint === true) {
    return CUSTOM_MCP_TOOL_ACCESS.READ;
  }
  if (typeof tool.destructiveHint === 'boolean') {
    return CUSTOM_MCP_TOOL_ACCESS.WRITE;
  }
  return CUSTOM_MCP_TOOL_ACCESS.UNSPECIFIED;
};

module.exports = {
  CUSTOM_MCP_TOOL_ACCESS,
  getCustomMcpToolDeclaredAccess,
};
